// extracted by mini-css-extract-plugin
export default {"footer_main":"Footer_footer_main__ZDcZ5","footer_content":"Footer_footer_content__s8paV","foot_pd":"Footer_foot_pd__Gcgln"};